
import axios from "axios";
import check from "~/store/elementChecker";

export default {
  data() {
    return {
      item: {},
      failed: false,
      ready: false,
    };
  },

  watchQuery: true,
  async asyncData({ req, app, params, store, route, redirect }) {
    try {
      await store.commit("itemReady", false);
      let host = "";
      if (process.server) {
        host = req.headers.host + route.fullPath;
      } else {
        host = location.host + route.fullPath;
      }
      host = encodeURIComponent(host);
      let temp = {};
      let item = {};
      let id = (params.id || "").split("+")[0];
      try {
        if (params.id.split("----")[1]) {
          id = params.id.split("---")[0].split("+")[0];
        } else if (params.id.split("---")[1]) {
          id = params.id.split("---")[1];
        } else if (params.id.split("--")[1]) {
          id = params.id.split("--")[1];
        }
      } catch (error) {}
      let url = `${process.env.axiosUrl}/items/${
        (store.state.store.eshop.search || "").includes("elastic") ? "sv/" : ""
      }store/${store.state.store.store_id}?store_id=${
        store.state.store.store_id
      }&direct=true&q=${encodeURIComponent(id)}`;
      try {
        temp = await axios.get(url, {
          headers: {
            shopster: host,
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        if ((temp.data || {}).newurl) {
          redirect(301, (temp.data.newurl || "").replace(/\ /g, ""));
        }
      } catch (e) {
        console.error(e);
        return { item };
      }
      if (!(((temp.data || {}).items || {}).docs || []).length) {
        let failed = { failed: true };
        await store.commit("item", { images: [], prices: {} });
        return { failed };
      }
      let tp = await app.$hyperItem.prepareItems((temp.data.items || {}).docs);
      item = (tp || [])[0];
      if (
        !route.path.includes("--") &&
        !route.path.includes("+") &&
        !route.path.includes("%2B")
      ) {
        console.warn("redirected");
        return redirect(
          301,
          `${(route.fullPath || "").split("?")[0]}+${encodeURIComponent(
            app.$hyperUtility.slugifyGreek(item.page_title || item.description)
          )}?${(route.fullPath || "").split("?")[1] || ""}`
        );
      }
      let preview = "";
      if (app.$cookies.get("preview")) {
        let pr = (app.$cookies.get("preview") || "").split(":::");
        if (pr[1] == store.getters.store.id) {
          preview = `&preview=${pr[0]}`;
        }
      }
      // check(
      //   store.getters.store.id,
      //   route,
      //   app,
      //   preview,
      //   ((store.getters.store || {}).build_no || {}).timestamp,
      //   (store.getters.store.build || {}).build_no
      // );
      await store.commit("item", item);
      await store.commit("itemReady", true);
      try {
        let res = await axios.get(
          `${process.env.axiosUrl}/stores/${
            store.getters.store.id
          }?elements=item&build=${
            (store.getters.store.build || {}).build_no
          }&&styleless=true&elementsonly=true${preview}`,
          {
            headers: {
              shopster: host,
            },
          }
        );
        if ((res.data || {}).id) {
          console.time('prepareElements')
          await store.dispatch("prepareElements", {
            state: store.state,
            item: item,
            elements: [
              ...store.getters.store.eshop.elements.filter((e) => e.static),
              ...res.data.eshop.elements,
            ],
            app,
          });
          console.timeEnd('prepareElements')
        }
      } catch (e) {
        console.error(e);
      }
      store.commit("history", { type: "item", item });
      return { item };
    } catch (error) {
      console.error(error);
      await store.commit("itemReady", true);
      let failed = { failed: true };
      return { failed };
    }
  },
  head() {
    let comment = false;
    if ((this.$store.getters.item || {}).comment) {
      comment = `${(this.$store.getters.item.comment || "")
        .replace(/<[^>]+>/g, "")
        .slice(0, 150)}...`;
    }
    return {
      favicon: this.$store.getters.store.eshop.favicon,
      title: (this.$store.getters.item || {}).page_title
        ? this.$store.getters.item.page_title
        : `${this.$store.getters.item.description || "Καταργήθηκε"} - ${
            this.$store.getters.store.name
          }`,
      meta: [
        ...this.$hyperSeo.meta(
          !this.$store.getters.item || !this.$store.getters.item?.description
            ? {}
            : {
                description:
                  (this.$store.getters.item || {}).seo_description ||
                  comment ||
                  `${
                    this.$store.getters.item.description
                  }, Τιμή ${this.$hyperItem.actualPrice(
                    this.$store.getters.item
                  )}, Εκδότης/Κατασκευαστής: ${
                    this.$store.getters.item.manufacturer
                  }, Κατηγορία: ${this.$store.getters.item.family}, ${
                    this.$store.getters.item.subfamily
                  }`,
                keywords:
                  this.$store.getters.item.seo_keywords ||
                  `${this.$store.getters.item.business_activity} ${this.$store.getters.item.family} ${this.$store.getters.item.subfamily} ${this.$store.getters.item.category}`,
              }
        ),
        ...this.$hyperSeo.og(
          !this.$store.getters.item || !this.$store.getters.item?.description
            ? {}
            : {
                "og:description":
                  (this.$store.getters.item || {}).seo_description ||
                  comment ||
                  `${
                    this.$store.getters.item.description
                  }, Τιμή ${this.$hyperItem.actualPrice(
                    this.$store.getters.item
                  )}, Εκδότης/Κατασκευαστής: ${
                    this.$store.getters.item.manufacturer
                  }, Κατηγορία: ${this.$store.getters.item.family}, ${
                    this.$store.getters.item.subfamily
                  }`,
                "og:image": ((this.$store.getters.item || {}).images || [])[0],
                "og:title": this.$store.getters.item.description,
                "og:type": "product",
              }
        ),
      ],
      script: [this.$hyperSeo.ld("item", this.$store.getters.item)],
    };
  },
  beforeRouteEnter(from, to, next) {
    if (to.name == "item-id" && process.browser) {
      (document.querySelectorAll(".type-coreHtml script") || []).forEach((e) =>
        e.remove()
      );
    }
    next();
  },
};
